import React, { useEffect } from "react";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import SubscriptionTierRoutes from "./subscriptiontiers/subscriptiontier.routes";
import { pushRoute } from "../../../../app/store/actions";
import { useDispatch } from "react-redux";
import {useParams} from 'react-router'
import { ROUTES } from "../../../../../history";
import SpecializationRoutes from "./specializations/specializations.routes";
import OthersRoutes from "./others/others.routes";



interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const Routes = [
    '/base',
    '/doctor-specializations',
    '/tiers'
]

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,

    sx: {
      fontFamily: "Lato, sans-serif",
      fontWeight: "bold",
      // textTransform: "none"
    },
  };
}
const Pages = Routes.reduce((a, r, i) => ({
    ...a,
    [r.slice(1)]: i
}), {}) as Record<string, number>;

const AppSettings = () => {
  const [value, setValue] = React.useState(0);
  const dispatch = useDispatch();
  
  const route = useParams();
  useEffect(() => {
    if(route.page) {
  

        const thePage = (Pages[route.page] || 0 )as number;
        if(thePage !== value) {
            setValue(thePage);
        }
    }
  }, [route, value])


  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
  
  
        dispatch(pushRoute({route: (ROUTES.ADMIN_BASE + '/settings/app-settings' +  Routes[newValue % 3]) as any}))

    setValue(newValue);
  };
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{ borderBottom: 1, borderColor: "divider" }}
        alignContent={"center"}
        alignItems={"center"}
        display="flex"
        justifyContent={"center"}
      >
        <Box sx={{ maxWidth: 500 }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            textColor="inherit"
            variant="fullWidth"
          >
            <Tab label={"Basic Settings"} {...a11yProps(0)} />
            <Tab label={"Specializations"} {...a11yProps(1)} />
            <Tab label={"Subscription Tiers"} {...a11yProps(0)} />
          </Tabs>
        </Box>
      </Box>

      <TabPanel value={value} index={0}>
       <OthersRoutes />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <SpecializationRoutes />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <SubscriptionTierRoutes />
      </TabPanel>
    </Box>
  );
};

export default AppSettings;
